import { CTMSUI } from 'src/types/KeyCloak';
import { ITabLevelHierarchy } from 'src/types/TabsType';
import DataMonitoringPage from '../Conduct/DataMonitoring/DataMonitoringPage';
import ConductSiteDocumentsPage from '../Conduct/SiteDocuments/SiteDocumentsPage';
import SubjectTrackingPage from '../Conduct/SubjectTracking/SubjectTrackingPage';
import IpManagementPage from '../StartUp/ipManagement/IpManagement';
import MilestoneTracking from '../StartUp/milestoneTracking/MilestoneTracking';
import SiteDocumentsPage from '../StartUp/siteDocuments/SiteDocumentsPage';
import SQChecklistView from '../StartUp/sqChecklist';
import SQReportView from '../StartUp/sqReport';
import StartupPacket from '../StartUp/startupPacket/StartupPacket';
import SiteContactInfo from '../StartUp/steps/SiteContactInfo';
import StudyReportsPage from 'src/components/common/StudyReports/StudyReportsPage';
import TasksPage from 'src/components/common/Tasks/TasksPage';
import CovChecklistPage from '../CloseOut/CovChecklist/CovChecklistPage';
import CovReportPage from '../CloseOut/CovReport/CovReportPage';
import EssentialDocsPage from '../CloseOut/EssentialDocuments/EssentialDocsPage';
import StudyLogsPage from '../CloseOut/StudyLogs/StudyLogsPage';
import { TabOne as CloseOutTabOne } from '../CloseOut/TabOne';
import DataReview from '../Conduct/DataMonitoring/DataReview';
import { PatientTrialNoteBook } from '../Conduct/PatientTrialNoteBook';
import { TabOne as ConductTabOne } from '../Conduct/TabOne';
import TrailEligiblePatientInfo from '../Conduct/TrialEligiblePatientInfo';
import { Summary } from '../StartUp/SummaryDashboard/Summary';
import StudyLogs1 from '../StartUp/studyLogs/StudyLogs1';
import { TabOne } from './TabOne';
import FeasibilityQuestionnaires from '../StartUp/feasibilityQuestionnaires';
import sivCheckListView from '../StartUp/sivChecklist';
import SIVReportView from '../StartUp/sivReport';
import ImvChecklist from '../Conduct/IMVChecklist';
import ImvReport from '../Conduct/IMVReport';
import DrugSupply from '../Conduct/DrugSupply';
import PendingShipment from '../Conduct/PendingShipment';

const clearableUptoStudyLevel: ITabLevelHierarchy = {
  Sponsor: false,
  Study: true,
  Country: true,
  Site: true
};

const noClearableLevel: ITabLevelHierarchy = {
  Sponsor: false,
  Study: false,
  Country: false,
  Site: false
};

export const MENU_GROUPS: any = {
  STARTUP: [
    {
      key: 'summary',
      index: 0,
      component: Summary,
      permissions: CTMSUI.VIEW_TSDA_STARTUP_SUMMARY,
      permissions_pil: '',
      NextButton: false,
      tabHierarchyLevels: noClearableLevel,
      archLevel: 'siteOnly'
    },
    {
      key: 'summary',
      index: 0,
      component: TabOne,
      permissions: CTMSUI.VIEW_STARTUP_SUMMARY,
      permissions_pil: '',
      NextButton: false,
      tabHierarchyLevels: noClearableLevel
    },
    {
      key: 'milestoneTracking',
      index: 1,
      component: MilestoneTracking,
      permissions: CTMSUI.VIEW_SITE_MILESTONES,
      permissions_pil: '',
      NextButton: false,
      tabHierarchyLevels: noClearableLevel,
      archLevel: 'site'
    },
    {
      key: 'siteContactInfo',
      index: 2,
      component: SiteContactInfo,
      permissions: CTMSUI.VIEW_SITE_CONTACT_INFO,
      permissions_pil: '',
      NextButton: false,
      tabHierarchyLevels: noClearableLevel,
      archLevel: 'site'
    },
    {
      key: 'startUpPacket',
      index: 3,
      component: StartupPacket,
      permissions: CTMSUI.VIEW_START_UP_PACKET,
      permissions_pil: '',
      NextButton: false,
      tabHierarchyLevels: noClearableLevel,
      archLevel: 'site'
    },
    {
      key: 'feasibilityQuestionnaires',
      index: 4,
      component: FeasibilityQuestionnaires,
      permissions: CTMSUI.VIEW_TUDA_FEASIBILITY,
      permissions_pil: CTMSUI.VIEW_TSDA_FEASIBILITY,
      NextButton: false,
      tabHierarchyLevels: noClearableLevel,
      archLevel: 'site'
    },
    {
      key: 'sqChecklist',
      index: 5,
      component: SQChecklistView,
      permissions: CTMSUI.VIEW_SQ_CHECKLIST,
      permissions_pil: CTMSUI.VIEW_SQ_CHECKLIST_PIL,
      NextButton: false,
      tabHierarchyLevels: noClearableLevel,
      archLevel: 'site'
    },
    {
      key: 'sqReport',
      index: 6,
      component: SQReportView,
      permissions: CTMSUI.VIEW_SQ_REPORT,
      permissions_pil: CTMSUI.VIEW_SQ_REPORT_AFTER_SUBMIT,
      NextButton: false,
      tabHierarchyLevels: noClearableLevel
    },
    {
      key: 'essentialDocuments',
      index: 7,
      component: SiteDocumentsPage,
      permissions: CTMSUI.VIEW_ESSENTIAL_DOCS,
      permissions_pil: '',
      NextButton: false,
      tabHierarchyLevels: noClearableLevel,
      archLevel: 'site'
    },
    {
      key: 'ipManagement',
      index: 8,
      component: IpManagementPage,
      permissions: CTMSUI.VIEW_IP_MANAGEMENT,
      permissions_pil: '',
      NextButton: false,
      tabHierarchyLevels: noClearableLevel,
      archLevel: 'site'
    },
    {
      key: 'sivChecklist',
      index: 9,
      component: sivCheckListView,
      permissions: CTMSUI.VIEW_SIV_CHECKLIST,
      permissions_pil: false,
      NextButton: false,
      tabHierarchyLevels: noClearableLevel
    },
    {
      key: 'sivReport',
      index: 10,
      component: SIVReportView,
      permissions: CTMSUI.VIEW_SIV_REPORT,
      permissions_pil: '',
      NextButton: false,
      tabHierarchyLevels: noClearableLevel,
      archLevel: 'site'
    },
    {
      key: 'studyLogs',
      index: 11,
      component: StudyLogs1,
      permissions: CTMSUI.VIEW_STUDY_LOGS,
      permissions_pil: '',
      NextButton: false,
      tabHierarchyLevels: noClearableLevel,
      archLevel: 'site'
    },
    {
      key: 'studyReports',
      index: 12,
      component: StudyReportsPage,
      permissions: CTMSUI.VIEW_STARTUP_STUDYREPORTS,
      permissions_pil: '',
      NextButton: false,
      tabHierarchyLevels: noClearableLevel
    }
  ],
  CONDUCT: [
    {
      key: 'summary',
      index: 50,
      component: ConductTabOne,
      permissions: CTMSUI.VIEW_CONDUCT_SUMMARY,
      permissions_pil: '',
      NextButton: false,
      tabHierarchyLevels: noClearableLevel
    },
    {
      key: 'conductMilestoneTracking',
      index: 51,
      component: MilestoneTracking,
      permissions: CTMSUI.VIEW_CONDUCT_MILESTONE_TRACKING,
      permissions_pil: '',
      NextButton: false,
      tabHierarchyLevels: clearableUptoStudyLevel,
      archLevel: 'site'
    },
    {
      key: 'trialEligiblePatients',
      index: 51,
      component: TrailEligiblePatientInfo,
      permissions: CTMSUI.VIEW_TRIALELIGIBLE_PATIENTS,
      permissions_pil: '',
      NextButton: false,
      tabHierarchyLevels: noClearableLevel,
      archLevel: 'siteOnly',
      searchHierarchy: false
    },
    {
      key: 'patientTrialNoteBook',
      index: 52,
      component: PatientTrialNoteBook,
      permissions: CTMSUI.VIEW_PATIENT_TRIAL_NOTEBOOK,
      permissions_pil: '',
      NextButton: false,
      tabHierarchyLevels: noClearableLevel,
      archLevel: 'siteOnly'
    },
    {
      key: 'subjectTracking',
      index: 52,
      component: SubjectTrackingPage,
      permissions: CTMSUI.VIEW_SUBJECT_TRACKING,
      permissions_pil: '',
      NextButton: false,
      tabHierarchyLevels: clearableUptoStudyLevel
    },
    {
      key: 'dataReview',
      index: 53,
      component: DataReview,
      permissions: CTMSUI.VIEW_CLINICAL_TRIAL_DATA_REVIEW,
      permissions_pil: '',
      NextButton: false,
      tabHierarchyLevels: clearableUptoStudyLevel,
      archLevel: 'site'
    },
    {
      key: 'dataMonitoring',
      index: 54,
      component: DataMonitoringPage,
      permissions: CTMSUI.VIEW_CONDUCT_DATAMONITORING,
      permissions_pil: '',
      NextButton: false,
      tabHierarchyLevels: clearableUptoStudyLevel
    },
    {
      key: 'imvChecklist',
      index: 55,
      component: ImvChecklist,
      permissions: CTMSUI.VIEW_IMVCHECKLIST,
      permissions_pil: '',
      NextButton: false,
      tabHierarchyLevels: clearableUptoStudyLevel
    },
    {
      key: 'imvReport',
      index: 56,
      component: ImvReport,
      permissions: CTMSUI.VIEW_CONDUCT_SUMMARY,
      permissions_pil: '',
      NextButton: false,
      tabHierarchyLevels: clearableUptoStudyLevel
    },
    {
      key: 'studyLogs',
      index: 57,
      component: StudyLogs1,
      permissions: CTMSUI.VIEW_CONDUCTSTUDYLOGS,
      permissions_pil: '',
      NextButton: false,
      tabHierarchyLevels: clearableUptoStudyLevel,
      archLevel: 'site'
    },
    {
      key: 'conductSiteDocuments',
      index: 58,
      component: ConductSiteDocumentsPage,
      permissions: CTMSUI.VIEW_CONDUCT_SUMMARY,
      permissions_pil: '',
      NextButton: false,
      tabHierarchyLevels: clearableUptoStudyLevel
    },
    {
      key: 'studyReports',
      index: 11,
      component: StudyReportsPage,
      permissions: CTMSUI.VIEW_CONDUCT_STUDYREPORTS,
      permissions_pil: '',
      NextButton: false,
      tabHierarchyLevels: clearableUptoStudyLevel
    },
    {
      key: 'drugSupply',
      index: 59,
      component: DrugSupply,
      permissions: CTMSUI.VIEW_DRUG_SUPPLY,
      permissions_pil: '',
      NextButton: false,
      tabHierarchyLevels: noClearableLevel,
      showHierarchy: ['sponsor', 'study']
    },
    {
      key: 'pendingShipments',
      index: 60,
      component: PendingShipment,
      permissions: CTMSUI.VIEW_PENDING_SHIPMENTS,
      permissions_pil: '',
      NextButton: false,
      tabHierarchyLevels: noClearableLevel,
      showHierarchy: ['sponsor', 'study']
    },
    {
      key: 'ipManagement',
      index: 61,
      component: IpManagementPage,
      permissions: CTMSUI.VIEW_IP_MANAGEMENT,
      permissions_pil: '',
      NextButton: false,
      tabHierarchyLevels: noClearableLevel,
      archLevel: 'site'
    },
    {
      key: 'tasks',
      index: 12,
      component: TasksPage,
      permissions: CTMSUI.VIEW_CONDUCT_TASKS,
      permissions_pil: '',
      NextButton: false,
      tabHierarchyLevels: clearableUptoStudyLevel
    }
  ],
  CLOSEOUT: [
    {
      key: 'summary',
      index: 100,
      component: CloseOutTabOne,
      permissions: CTMSUI.VIEW_CLOSEOUT_SUMMARY,
      permissions_pil: '',
      NextButton: false,
      tabHierarchyLevels: noClearableLevel,
      archLevel: 'site'
    },
    {
      key: 'covChecklist',
      index: 101,
      component: CovChecklistPage,
      permissions: CTMSUI.VIEW_CLOSEOUT_COVCHECKLIST,
      permissions_pil: '',
      NextButton: false,
      tabHierarchyLevels: noClearableLevel,
      archLevel: 'site'
    },
    {
      key: 'covReport',
      index: 102,
      component: CovReportPage,
      permissions: CTMSUI.VIEW_CLOSEOUT_COVREPORT,
      permissions_pil: '',
      NextButton: false,
      tabHierarchyLevels: noClearableLevel,
      archLevel: 'site'
    },
    {
      key: 'essentialDocuments',
      index: 103,
      component: EssentialDocsPage,
      permissions: CTMSUI.VIEW_CLOSEOUT_ESSENTIALDOCUMENTS,
      permissions_pil: '',
      NextButton: false,
      tabHierarchyLevels: noClearableLevel,
      archLevel: 'site'
    },
    {
      key: 'studyLogs',
      index: 104,
      component: StudyLogsPage,
      permissions: CTMSUI.VIEW_CLOSEOUT_STUDYLOGS,
      permissions_pil: '',
      NextButton: false,
      tabHierarchyLevels: noClearableLevel,
      archLevel: 'site'
    }
  ]
};
